// extracted by mini-css-extract-plugin
export default {"list":"CoreList-module--list--ef6c4"};